import {
  Flavours,
  ProductChoices,
  Products,
} from '../../components/Catering/ProductDetailsPage/ProductInterface/ProductInterface';
import { multipleAndCheck, ternaryCheck } from '../../Utils/WindowUtils';
import {
  CONFIRMATION_MODAL_DATA,
  DECREMENT_MIAM_OPTION,
  DECREMENT_OPTION,
  HANDLE_BACK,
  INCREMENT_MIAM_OPTION,
  INCREMENT_OPTION,
  PDP_CONTINUE,
  PDP_MIAM_CONTINUE,
  REMOVE_TOPPINGS,
  RESET_DATA,
  SELECT_INGREDIENT,
  SELECT_MIAM_INGREDIENT,
  SELECT_TOPPING,
  SET_DATA,
  SET_PRODUCT_SIZE,
  SET_VARIANT_SIZE,
  SHOW_MODAL_DATA,
  SHOW_MORE,
} from '../actions/productActionTypes';
import { ActionType } from '../index.d';
import {
  checkAndReplace,
  decrementOperation,
  footerMIAMSelectedList,
  footerSelectedList,
  getProductHeaderInfo,
  getSelectedProduct,
  getSelectedProductChoices,
  getSelectedProductMIAMChoices,
  getSelectedProductsAndFlavours,
  getSelectedToppings,
  getShowMoreCounts,
  getToppingsArray,
  getUpdatedProducts,
  getVariantDetails,
  getVariantSize,
  ingredientMAIMSelectedQuantity,
  ingredientSelectedQuantity,
  isIncrementDisabledSelector,
  isMIAMIncrementDisabledSelector,
} from '../selectors/productSelector';
import { InitalStateData } from '../storeInterface';

const initialState: InitalStateData = {
  data: null,
  titleInfo: {
    productMainTitle: '',
    feedQuantityPhrase: '',
    description: '',
    shortDescription: '',
  },
  variantsInfo: {
    variants: [],
    reset: '',
    apply: '',
    customQuantityInfo: '',
    customQuantityTitle: '',
    customErrorInfo: '',
    variantTitle: '',
    maxOrderQuantity: 0,
    minOrderQuantity: 0,
  },
  selectedProduct: {},
  selectedSize: 0,
  isCustomSizeSelected: false,
  isIncrementDisabled: false,
  isMIAMIncrementDisabled: false,
  selectedProductsAndFlavours: {
    itemId: "",
    description: "",
    productType: "",
    quantity: 1,
    price: 0,
    choices: []
  },
  selectedProductChoices: [],
  selectedProductToppings: [],
  selectedProductMIAMChoices: [],
  productLimit: {
    isProductLimit: false,
    isQuantityLess: false,
    productWarnMessage: '',
  },
  isPDPContinue: false,
  isMIAMShow: false,
  remainingChoicesLeft: null,
  MIAMChoiceIndex: 0,
  pdpFooterSelectedList: '',
  showMoreCount: {},
  isShowModal: { isSuccess: false, isFailure: false },
  confirmationModalData: {}
};
export const productReducer = (state = initialState, action: ActionType) => {
  switch (action?.type) {
    case SET_DATA: {
      const { data } = action.payload;
      const variantSizeSelection = getVariantSize(data);
      const updatedData = getUpdatedProducts(data, variantSizeSelection);

      return {
        ...state,
        titleInfo: getProductHeaderInfo(data),
        variantsInfo: getVariantDetails(data),
        data: { ...data, products: updatedData },
        selectedProduct: getSelectedProduct(updatedData),
        selectedProductChoices: getSelectedProductChoices(updatedData),
        selectedProductToppings: getSelectedToppings(updatedData),
        selectedProductMIAMChoices: getSelectedProductMIAMChoices(updatedData),
        selectedProductsAndFlavours: getSelectedProductsAndFlavours(updatedData),
        selectedSize: variantSizeSelection,
        isCustomSizeSelected: initialState.isCustomSizeSelected,
        isIncrementDisabled: isIncrementDisabledSelector(updatedData, variantSizeSelection),
        productLimit: {
          isProductLimit: initialState.productLimit.isProductLimit,
          isQuantityLess: initialState.productLimit.isQuantityLess,
          productWarnMessage: initialState.productLimit.productWarnMessage,
        },
        isPDPContinue: false,
        pdpFooterSelectedList: footerSelectedList(updatedData),
        showMoreCount: getShowMoreCounts(updatedData),
      };
    }
    case SET_VARIANT_SIZE:
      const { size, isCustom } = action.payload;
      if (!state.data) {
        return { ...state };
      }
      const updatedProductData = getUpdatedProducts(state.data, size);

      return {
        ...state,
        data: { ...state.data, products: updatedProductData },
        selectedProduct: getSelectedProduct(updatedProductData),
        selectedProductChoices: getSelectedProductChoices(updatedProductData),
        selectedProductMIAMChoices: getSelectedProductMIAMChoices(updatedProductData),
        selectedProductsAndFlavours: getSelectedProductsAndFlavours(updatedProductData),
        selectedSize: Number(size),
        isCustomSizeSelected: isCustom,
        productLimit: {
          isProductLimit: initialState.productLimit.isProductLimit,
          isQuantityLess: initialState.productLimit.isQuantityLess,
          productWarnMessage: initialState.productLimit.productWarnMessage,
        },
        isPDPContinue: false,
        pdpFooterSelectedList: footerSelectedList(updatedProductData),
      };
    case RESET_DATA:
      if (!state.data) {
        return { ...state };
      }
      const variantSize: number = getVariantSize(state?.data);
      const updatedInitialData = state.data
        ? getUpdatedProducts(state?.data, variantSize)
        : state.data;
      return {
        ...state,
        data: { ...state.data, products: updatedInitialData },
        selectedSize: variantSize,
        isCustomSizeSelected: initialState.isCustomSizeSelected,
        selectedProduct: getSelectedProduct(updatedInitialData),
        selectedProductChoices: getSelectedProductChoices(updatedInitialData),
        selectedProductMIAMChoices: getSelectedProductMIAMChoices(updatedInitialData),
        selectedProductsAndFlavours: getSelectedProductsAndFlavours(updatedInitialData),
        productLimit: {
          isProductLimit: initialState.productLimit.isProductLimit,
          isQuantityLess: initialState.productLimit.isQuantityLess,
          productWarnMessage: initialState.productLimit.productWarnMessage,
        },
        isPDPContinue: false,
        pdpFooterSelectedList: footerSelectedList(updatedInitialData),
      };
    case SET_PRODUCT_SIZE:
      const productId = action.payload;

      const updatedProducts: Products[] =
        state?.data?.products.map((product: Products) => {
          if (product.productId === productId) {
            return {
              ...product,
              selected: true,
            };
          }
          return {
            ...product,
            selected: false,
          };
        }) || [];

      return {
        ...state,
        data: { ...state.data, products: updatedProducts },
        selectedProduct: getSelectedProduct(updatedProducts),
        selectedProductChoices: getSelectedProductChoices(updatedProducts),
        selectedProductMIAMChoices: getSelectedProductMIAMChoices(updatedProducts),
        selectedProductsAndFlavours: getSelectedProductsAndFlavours(updatedProducts),
        productLimit: {
          isProductLimit: initialState.productLimit.isProductLimit,
          isQuantityLess: initialState.productLimit.isQuantityLess,
          productWarnMessage: initialState.productLimit.productWarnMessage,
        },
        isPDPContinue: false,
        pdpFooterSelectedList: footerSelectedList(updatedProducts),
      };

    case INCREMENT_OPTION:
      const { incrementOptionId, itemID: incrementGroupId } = action.payload;
      let productLimitMessage;
      let isProductLimit = false;
      let isLessQuantity = false;

      const incrementedProducts =
        state?.data?.products.map((product: Products) => {
          return {
            ...product,
            productChoices: product.productChoices.map((group: ProductChoices) => {
              if (group.id !== incrementGroupId) return group;

              const totalQuantity = group.flavours
                .filter(option => option.selected)
                .reduce((sum, option) => sum + option.quantity, 0);

              return {
                ...group,
                flavours: group.flavours.map((option: Flavours) => {
                  if (option.id === incrementOptionId) {
                    if (totalQuantity < state.selectedSize) {
                      return {
                        ...option,
                        quantity: option.quantity + 1,
                        selected: true,
                      };
                    } else {
                      productLimitMessage = state.data?.productLimitWarmingText;
                      isProductLimit = true;
                    }
                  }
                  return option;
                }),
              };
            }),
          };
        }) || [];

      const totalIngQuantity = ingredientSelectedQuantity(incrementedProducts);

      if (totalIngQuantity != state.selectedSize) {
        isProductLimit = true;
        isLessQuantity = true;
        productLimitMessage = checkAndReplace(
          state.data?.productWarningText,
          state.selectedSize - totalIngQuantity,
          state.selectedProductChoices[0]?.title,
        );
      }

      return {
        ...state,
        data: {
          ...state.data,
          products: incrementedProducts,
        },
        selectedProduct: getSelectedProduct(incrementedProducts),
        isIncrementDisabled: isIncrementDisabledSelector(incrementedProducts, state.selectedSize),
        selectedProductChoices: getSelectedProductChoices(incrementedProducts),
        selectedProductsAndFlavours: getSelectedProductsAndFlavours(incrementedProducts),
        productLimit: {
          isProductLimit: isProductLimit,
          productWarnMessage: productLimitMessage,
          isQuantityLess: isLessQuantity,
        },
        isPDPContinue: false,
        pdpFooterSelectedList: footerSelectedList(incrementedProducts),
      };

    case DECREMENT_OPTION:
      const { decrementOptionId, itemID: decrementGroupId } = action.payload;
      let quantityError;
      let isQuantityError = false;
      let isLessQuant = false;
      const decrementedProducts =
        state?.data?.products.map((product: Products) => {
          return {
            ...product,
            productChoices: product.productChoices.map((group: ProductChoices) => {
              if (group.id !== decrementGroupId) return group;

              return {
                ...group,
                flavours: decrementOperation(group, decrementOptionId),
              };
            }),
          };
        }) || [];

      const totalQuantityIngredient = ingredientSelectedQuantity(decrementedProducts);

      if (totalQuantityIngredient != state.selectedSize) {
        isQuantityError = true;
        isLessQuant = true;
        quantityError = checkAndReplace(
          state.data?.productWarningText,
          state.selectedSize - totalQuantityIngredient,
          state.selectedProductChoices[0]?.title,
        );
      }

      return {
        ...state,
        data: {
          ...state.data,
          products: decrementedProducts,
        },
        selectedProduct: getSelectedProduct(decrementedProducts),
        isIncrementDisabled: isIncrementDisabledSelector(decrementedProducts, state.selectedSize),
        selectedProductChoices: getSelectedProductChoices(decrementedProducts),
        selectedProductsAndFlavours: getSelectedProductsAndFlavours(decrementedProducts),
        productLimit: {
          isProductLimit: isQuantityError,
          isQuantityLess: isLessQuant,
          productWarnMessage: quantityError,
        },
        isPDPContinue: false,
        pdpFooterSelectedList: footerSelectedList(decrementedProducts),
      };
    case SELECT_INGREDIENT:
      const { optionId, itemID } = action.payload;
      let limitMessage;
      let isLimit = false;
      let lessQuantity = false;

      const selectedProducts =
        state?.data?.products.map((product: Products) => {
          return {
            ...product,
            productChoices: product.productChoices.map((group: ProductChoices) => {
              if (group.id !== itemID) return group;

              const totalQuantityflavours = group.flavours.reduce(
                (total, option) => total + (option.selected ? option.quantity : 0),
                0,
              );

              return {
                ...group,
                flavours: group.flavours.map((option: Flavours) => {
                  if (option.id === optionId) {
                    if (!option.selected) {
                      const newTotalQuantity = totalQuantityflavours + 1;

                      if (newTotalQuantity <= state.selectedSize) {
                        return {
                          ...option,
                          selected: true,
                          quantity: 1,
                        };
                      } else {
                        limitMessage = state.data?.productLimitWarmingText;
                        isLimit = true;
                      }
                    }
                  }
                  return option;
                }),
              };
            }),
          };
        }) || [];

      const totalIngredientQuantity = ingredientSelectedQuantity(selectedProducts);

      if (totalIngredientQuantity != state.selectedSize) {
        isLimit = true;
        lessQuantity = true;
        limitMessage = checkAndReplace(
          state.data?.productWarningText,
          state.selectedSize - totalIngredientQuantity,
          state.selectedProductChoices[0]?.title,
        );
      }

      return {
        ...state,
        data: { ...state.data, products: selectedProducts },
        selectedProduct: getSelectedProduct(selectedProducts),
        isIncrementDisabled: isIncrementDisabledSelector(selectedProducts, state.selectedSize),
        selectedProductChoices: getSelectedProductChoices(selectedProducts),
        selectedProductsAndFlavours: getSelectedProductsAndFlavours(selectedProducts),
        productLimit: {
          isProductLimit: isLimit,
          productWarnMessage: limitMessage,
          isQuantityLess: lessQuantity,
        },
        isPDPContinue: false,
        pdpFooterSelectedList: footerSelectedList(selectedProducts),
      };

    case PDP_CONTINUE:
      if (!state.data) {
        return { ...state };
      }
      const totalQty = ingredientSelectedQuantity(state?.data?.products);

      return {
        ...state,
        isPDPContinue: ternaryCheck(totalQty !== state.selectedSize, true, false),
        remainingChoicesLeft: ternaryCheck(
          multipleAndCheck(
            state.selectedProductMIAMChoices.length > 0 && totalQty === state.selectedSize,
          ),
          state.selectedProductMIAMChoices.length - 1,
          initialState.remainingChoicesLeft,
        ),
        productLimit: ternaryCheck(
          totalQty === state.selectedSize,
          {
            isProductLimit: false,
            isQuantityLess: false,
            productWarnMessage: '',
          },
          state.productLimit,
        ),
        isMIAMShow: ternaryCheck(totalQty === state.selectedSize, true, false),
        MIAMChoiceIndex: initialState.MIAMChoiceIndex,
        pdpFooterSelectedList: ternaryCheck(
          totalQty === state.selectedSize,
          footerMIAMSelectedList(state.data?.products, initialState.MIAMChoiceIndex),
          state.pdpFooterSelectedList,
        ),
        isMIAMIncrementDisabled: isMIAMIncrementDisabledSelector(
          state?.data?.products,
          state.selectedSize,
          initialState.MIAMChoiceIndex,
        ),
        selectedProductsAndFlavours: getSelectedProductsAndFlavours(state?.data?.products),
      };
    case PDP_MIAM_CONTINUE:
      const { index, choiceLeft } = action.payload;
      let quantityConError;
      let isQuantityConError = false;
      let isLessConQuant = false;
      if (!state.data) {
        return { ...state };
      }
      const totalMIAMQty = ingredientMAIMSelectedQuantity(state?.data?.products, index);
      if (totalMIAMQty != state.selectedSize) {
        isQuantityConError = true;
        isLessConQuant = true;
        quantityConError = checkAndReplace(
          state.data?.productWarningText,
          state.selectedSize - totalMIAMQty,
          state.selectedProductMIAMChoices?.[index]?.title,
        );
      }
      return {
        ...state,
        isPDPContinue: ternaryCheck(totalMIAMQty !== state.selectedSize, true, false),
        remainingChoicesLeft: ternaryCheck(
          totalMIAMQty === state.selectedSize,
          choiceLeft,
          state.remainingChoicesLeft,
        ),
        MIAMChoiceIndex: ternaryCheck(
          totalMIAMQty === state.selectedSize,
          index + 1,
          state.MIAMChoiceIndex,
        ),
        pdpFooterSelectedList: ternaryCheck(
          totalMIAMQty === state.selectedSize,
          footerMIAMSelectedList(state.data?.products, index + 1),
          state.pdpFooterSelectedList,
        ),
        isMIAMIncrementDisabled: ternaryCheck(
          totalMIAMQty === state.selectedSize,
          isMIAMIncrementDisabledSelector(state?.data?.products, state.selectedSize, index + 1),
          state.isMIAMIncrementDisabled,
        ),
        productLimit: ternaryCheck(totalMIAMQty === state.selectedSize, initialState.productLimit, {
          isProductLimit: isQuantityConError,
          isQuantityLess: isLessConQuant,
          productWarnMessage: quantityConError,
        }),
        selectedProductsAndFlavours: getSelectedProductsAndFlavours(state?.data?.products),
      };

    case HANDLE_BACK:
      const { index: MIAMIdx, choiceLeft: remainingLeft } = action.payload;
      if (!state.data) {
        return { ...state };
      }
      const decMIAMIndex = ternaryCheck(MIAMIdx > 0, MIAMIdx - 1, initialState.MIAMChoiceIndex)
      return {
        ...state,
        isPDPContinue: false,
        remainingChoicesLeft: ternaryCheck(
          MIAMIdx > 0,
          remainingLeft + 1,
          initialState.remainingChoicesLeft,
        ),
        MIAMChoiceIndex: decMIAMIndex,
        pdpFooterSelectedList: ternaryCheck(
          MIAMIdx > 0,
          footerMIAMSelectedList(state.data?.products, decMIAMIndex),
          footerSelectedList(state.data?.products),
        ),
        selectedProductMIAMChoices: ternaryCheck(
          MIAMIdx > 0,
          getSelectedProductMIAMChoices(state.data?.products),
          state.selectedProductMIAMChoices,
        ),
        selectedProductChoices: ternaryCheck(
          MIAMIdx > 0,
          state.selectedProductChoices,
          getSelectedProductChoices(state.data?.products),
        ),
        isMIAMShow: ternaryCheck(MIAMIdx > 0, true, initialState.isMIAMShow),
        isMIAMIncrementDisabled: ternaryCheck(
          MIAMIdx > 0,
          isMIAMIncrementDisabledSelector(
            state?.data?.products,
            state.selectedSize,
            initialState.MIAMChoiceIndex,
          ),
          initialState.isMIAMIncrementDisabled,
        ),
        isIncrementDisabled: ternaryCheck(
          MIAMIdx > 0,
          initialState.isIncrementDisabled,
          isIncrementDisabledSelector(state?.data?.products, state.selectedSize),
        ),
        productLimit: {
          isProductLimit: false,
          isQuantityLess: false,
          productWarnMessage: '',
        },
        selectedProductsAndFlavours: getSelectedProductsAndFlavours(state?.data?.products),
      };

    case INCREMENT_MIAM_OPTION:
      const {
        incrementMIAMOptionId,
        itemID: incrementMIAMGroupId,
        index: MIAMIndex,
      } = action.payload;
      let productMIAMLimitMessage;
      let isProductMIAMLimit = false;
      let isMIAMLessQuantity = false;

      const incrementedMAIMProducts =
        state?.data?.products
          .filter((product: Products) => product.selected)
          .map((product: Products) => {
            const updatedINCMiamChoice = [...product.miamChoice];
            const selectedINCMiamChoice = updatedINCMiamChoice[MIAMIndex];

            if (selectedINCMiamChoice?.id === incrementMIAMGroupId) {
              const totalQuantityChoice = selectedINCMiamChoice.flavours
                .filter(option => option.selected)
                .reduce((sum, option) => sum + option.quantity, 0);
              updatedINCMiamChoice[MIAMIndex] = {
                ...selectedINCMiamChoice,
                flavours: selectedINCMiamChoice.flavours.map((option: Flavours) => {
                  if (option.id === incrementMIAMOptionId) {
                    if (totalQuantityChoice < state.selectedSize) {
                      return {
                        ...option,
                        quantity: option.quantity + 1,
                        selected: true,
                      };
                    } else {
                      productMIAMLimitMessage = state.data?.productLimitWarmingText;
                      isProductMIAMLimit = true;
                    }
                  }
                  return option;
                }),
              };
            }
            return {
              ...product,
              miamChoice: updatedINCMiamChoice,
            };
          }) || [];

      const totalMIAMIngQuantity = ingredientMAIMSelectedQuantity(
        incrementedMAIMProducts,
        MIAMIndex,
      );

      if (totalMIAMIngQuantity != state.selectedSize) {
        isProductMIAMLimit = true;
        isMIAMLessQuantity = true;
        productMIAMLimitMessage = checkAndReplace(
          state.data?.productWarningText,
          state.selectedSize - totalMIAMIngQuantity,
          state.selectedProductMIAMChoices?.[MIAMIndex]?.title,
        );
      }

      return {
        ...state,
        data: {
          ...state.data,
          products: incrementedMAIMProducts,
        },
        selectedProduct: getSelectedProduct(incrementedMAIMProducts),
        isPDPContinue: false,
        pdpFooterSelectedList: footerMIAMSelectedList(incrementedMAIMProducts, MIAMIndex),
        selectedProductMIAMChoices: getSelectedProductMIAMChoices(incrementedMAIMProducts),
        isMIAMIncrementDisabled: isMIAMIncrementDisabledSelector(
          incrementedMAIMProducts,
          state.selectedSize,
          MIAMIndex,
        ),
        productLimit: {
          isProductLimit: isProductMIAMLimit,
          productWarnMessage: productMIAMLimitMessage,
          isQuantityLess: isMIAMLessQuantity,
        },
        selectedProductsAndFlavours: getSelectedProductsAndFlavours(incrementedMAIMProducts),
      };
    case DECREMENT_MIAM_OPTION:
      const {
        decrementMIAMOptionId,
        itemID: decrementMIAMGroupId,
        index: MIAMChoiceIndex,
      } = action.payload;

      let quantityMAIMError;
      let isQuantityMIAMError = false;
      let isLessMIAMQuant = false;

      const decrementedMAIMProducts =
        state?.data?.products
          .filter((product: Products) => product.selected)
          .map((product: Products) => {
            const updatedDECMiamChoice = [...product.miamChoice];
            const selectedDECMiamChoice = updatedDECMiamChoice[MIAMChoiceIndex];

            if (selectedDECMiamChoice?.id === decrementMIAMGroupId) {
              updatedDECMiamChoice[MIAMChoiceIndex] = {
                ...selectedDECMiamChoice,
                flavours: decrementOperation(selectedDECMiamChoice, decrementMIAMOptionId),
              };
            }

            return {
              ...product,
              miamChoice: updatedDECMiamChoice,
            };
          }) || [];

      const totalMIAMDecQuantity = ingredientMAIMSelectedQuantity(
        decrementedMAIMProducts,
        MIAMChoiceIndex,
      );

      if (totalMIAMDecQuantity != state.selectedSize) {
        isQuantityMIAMError = true;
        isLessMIAMQuant = true;
        quantityMAIMError = checkAndReplace(
          state.data?.productWarningText,
          state.selectedSize - totalMIAMDecQuantity,
          state.selectedProductMIAMChoices?.[MIAMChoiceIndex]?.title
        );
      }

      return {
        ...state,
        data: {
          ...state.data,
          products: decrementedMAIMProducts,
        },
        selectedProduct: getSelectedProduct(decrementedMAIMProducts),
        isPDPContinue: false,
        pdpFooterSelectedList: footerMIAMSelectedList(decrementedMAIMProducts, MIAMChoiceIndex),
        selectedProductMIAMChoices: getSelectedProductMIAMChoices(decrementedMAIMProducts),
        isMIAMIncrementDisabled: isMIAMIncrementDisabledSelector(
          decrementedMAIMProducts,
          state.selectedSize,
          MIAMChoiceIndex,
        ),
        productLimit: {
          isProductLimit: isQuantityMIAMError,
          isQuantityLess: isLessMIAMQuant,
          productWarnMessage: quantityMAIMError,
        },
        selectedProductsAndFlavours: getSelectedProductsAndFlavours(decrementedMAIMProducts)
      };

    case SELECT_MIAM_INGREDIENT:
      const {
        optionId: MAIM_OPTIONID,
        itemID: MIAM_ITEMID,
        index: MIAMSelectIndex,
      } = action.payload;

      let limitMIAMMessage;
      let isMIAMLimit = false;
      let lessMIAMQuantity = false;

      const selectedMAIMProducts =
        state?.data?.products
          .filter((product: Products) => product.selected)
          .map((product: Products) => {
            const updatedIngMiamChoice = [...product.miamChoice];
            const selectedIngMiamChoice = updatedIngMiamChoice[MIAMSelectIndex];

            if (selectedIngMiamChoice?.id === MIAM_ITEMID) {
              const totalQuantityIngChoice = selectedIngMiamChoice.flavours.reduce(
                (total, option) => total + (option.selected ? option.quantity : 0),
                0,
              );
              updatedIngMiamChoice[MIAMSelectIndex] = {
                ...selectedIngMiamChoice,
                flavours: selectedIngMiamChoice.flavours.map((option: Flavours) => {
                  if (option.id === MAIM_OPTIONID) {
                    if (!option.selected) {
                      const newTotalMIAMQuantity = totalQuantityIngChoice + 1;
                      if (newTotalMIAMQuantity <= state.selectedSize) {
                        return {
                          ...option,
                          selected: true,
                          quantity: 1,
                        };
                      } else {
                        limitMIAMMessage = state.data?.productLimitWarmingText;
                        isMIAMLimit = true;
                      }
                    }
                  }
                  return option;
                }),
              };
            }
            return {
              ...product,
              miamChoice: updatedIngMiamChoice,
            };
          }) || [];

      const totalIngredientChoiceQuantity = ingredientMAIMSelectedQuantity(
        selectedMAIMProducts,
        MIAMSelectIndex,
      );

      if (totalIngredientChoiceQuantity != state.selectedSize) {
        isMIAMLimit = true;
        lessMIAMQuantity = true;
        limitMIAMMessage = checkAndReplace(
          state.data?.productWarningText,
          state.selectedSize - totalIngredientChoiceQuantity,
          state.selectedProductMIAMChoices?.[MIAMSelectIndex]?.title,
        );
      }

      return {
        ...state,
        data: { ...state.data, products: selectedMAIMProducts },
        selectedProduct: getSelectedProduct(selectedMAIMProducts),
        isPDPContinue: false,
        pdpFooterSelectedList: footerMIAMSelectedList(selectedMAIMProducts, MIAMSelectIndex),
        selectedProductMIAMChoices: getSelectedProductMIAMChoices(selectedMAIMProducts),
        isMIAMIncrementDisabled: isMIAMIncrementDisabledSelector(
          selectedMAIMProducts,
          state.selectedSize,
          MIAMSelectIndex,
        ),
        productLimit: {
          isProductLimit: isMIAMLimit,
          productWarnMessage: limitMIAMMessage,
          isQuantityLess: lessMIAMQuantity,
        },
        selectedProductsAndFlavours: getSelectedProductsAndFlavours(selectedMAIMProducts)
      };
    case REMOVE_TOPPINGS:
      const { optionId: toppingOptionID } = action.payload;
      const updateProductList = getToppingsArray(state?.data, toppingOptionID, false);
      return {
        ...state,
        data: { ...state.data, products: updateProductList },
        selectedProduct: getSelectedProduct(updateProductList),
        selectedProductToppings: getSelectedToppings(updateProductList),
        pdpFooterSelectedList: footerSelectedList(updateProductList),
        selectedProductsAndFlavours: getSelectedProductsAndFlavours(updateProductList)
      };

    case SELECT_TOPPING:
      const { optionId: toppingID } = action.payload;
      const selectTopping = getToppingsArray(state?.data, toppingID, true);
      return {
        ...state,
        data: { ...state.data, products: selectTopping },
        selectedProduct: getSelectedProduct(selectTopping),
        selectedProductToppings: getSelectedToppings(selectTopping),
        pdpFooterSelectedList: footerSelectedList(selectTopping),
        selectedProductsAndFlavours: getSelectedProductsAndFlavours(selectTopping)
      };

    case SHOW_MORE:
      const { groupID, additionalCount } = action.payload;
      return {
        ...state,
        showMoreCount: {
          ...state.showMoreCount,
          [groupID]: additionalCount,
        },
      };
    case SHOW_MODAL_DATA:
      const { showModalData } = action.payload;

      return {
        ...state,
        isShowModal: { isSuccess: showModalData?.isSuccess, isFailure: showModalData?.isFailure }
      }
    case CONFIRMATION_MODAL_DATA:
      const { responseData } = action.payload;
      return {
        ...state,
        confirmationModalData: responseData

      }
    default:
      return state;
  }
};
